'use client'

import { PdpClientLink } from 'links/pdp/client'
import type { PdpClientLinkProps } from 'links/pdp/types/PdpLink.types'
import { useProductCard } from 'product-card/hooks/useProductCard'
import { useProductCardConsumerLayoutContext } from 'product-card/hooks/useProductCardConsumerLayoutContext'
import { ImageDisplayType } from 'product-card/types'
import type { PropsWithChildren } from 'react'

type PdpImageLinkWrapperProps = PropsWithChildren<{
	readonly imageDisplayType: ImageDisplayType
	readonly isSEORelevant: boolean
	readonly className?: string
	readonly tabIndex?: number
}>

export const PdpImageLinkWrapper = ({
	children,
	imageDisplayType,
	isSEORelevant,
	tabIndex,
	className,
}: PdpImageLinkWrapperProps) => {
	const {
		product,
		lookId,
		selectedColorId,
		productListId,
		draggable,
		onImageClick,
	} = useProductCard()

	const { disableImageLink } = useProductCardConsumerLayoutContext()

	const pdpClientLinkProps: Omit<PdpClientLinkProps, 'children'> = {
		product,
		lookId,
		linkProps: {
			linkProps: {
				draggable,
				className,
				tabIndex,
				...(!isSEORelevant && { rel: 'nofollow' }),
			},
			onClick: onImageClick,
		},
		colorId: selectedColorId,
		listId: productListId,
		metaAs:
			imageDisplayType === ImageDisplayType.Slider && isSEORelevant
				? 'url'
				: undefined,
	}

	return disableImageLink ? (
		children
	) : (
		<PdpClientLink {...pdpClientLinkProps}>{children}</PdpClientLink>
	)
}
